import { Component, ojs, app } from "modular-openscriptjs";
import BsIcon from "./BsIcon";

const h = app("h");

ojs(BsIcon);

export default class SearchIconBtn extends Component {
	render(...args) {
		return h.a(
			{
				class: "d-none d-md-inline-block btn btn-outline-primary border-transparent position-relative nav-auth-btn",
				type: "button",
				data_bs_toggle: "offcanvas",
				data_bs_target: "#offcanvasSearch",
				aria_controls: "offcanvasSearch",
			},
			h.BsIcon("search"),
			...args
		);
	}
}
